module.exports = __webpack_public_path__ + "media/images/countryrect/aq-6ced3a3cce57036796166baacb8bb26e.svg";